import React from 'react';

import Head from 'next/head';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

import { getLayout } from 'src/layouts/SiteLayout/StaticPageLayout';
import styled from 'styled-components';
import { Card, CardBody, Col, Row } from 'reactstrap';

const Post = styled(Card)`
  margin: 20px auto;
  background-color: rgba(249, 250, 255, 0.4);
  border: 0;
`;

const PostTitle = styled.h2`
  color: #000;

  a:hover {
    color: #000;
    text-decoration: underline;
  }
`;

const Blog = () => {
  const { t } = useTranslation();

  const list = [
    {
      title: t('pages.blog.an-innovative-bot-that-will-lead-traffic-to-the-site.title'),
      description: t('pages.blog.an-innovative-bot-that-will-lead-traffic-to-the-site.description'),
      link: '/blog/an-innovative-bot-that-will-lead-traffic-to-the-site',
    },
    {
      title: t('pages.blog.how-to-prepare-a-website-before-you-buy-real-website-traffic.title'),
      description: t('pages.blog.how-to-prepare-a-website-before-you-buy-real-website-traffic.description'),
      link: '/blog/how-to-prepare-a-website-before-you-buy-real-website-traffic',
    },
    {
      title: t('pages.blog.how-to-generate-website-traffic-for-free.title'),
      description: t('pages.blog.how-to-generate-website-traffic-for-free.description'),
      link: '/blog/how-to-generate-website-traffic-for-free',
    },
    {
      title: t('pages.blog.google-adsense-traffic-generator-from-experienced-professionals.title'),
      description: t('pages.blog.google-adsense-traffic-generator-from-experienced-professionals.description'),
      link: '/blog/google-adsense-traffic-generator-from-experienced-professionals',
    },
    {
      title: t('pages.blog.free-targeted-traffic-generator-a-modern-tool-for-your-business.title'),
      description: t('pages.blog.free-targeted-traffic-generator-a-modern-tool-for-your-business.description'),
      link: '/blog/free-targeted-traffic-generator-a-modern-tool-for-your-business',
    },
    {
      title: t('pages.blog.how-to-use-website-traffic-booster-to-increase-profits.title'),
      description: t('pages.blog.how-to-use-website-traffic-booster-to-increase-profits.description'),
      link: '/blog/how-to-use-website-traffic-booster-to-increase-profits',
    },
    {
      title: t('pages.blog.how-to-get-web-traffic-free-for-digital-marketing.title'),
      description: t('pages.blog.how-to-get-web-traffic-free-for-digital-marketing.description'),
      link: '/blog/how-to-get-web-traffic-free-for-digital-marketing',
    },
    {
      title: t('pages.blog.free-traffic-that-converts-with-special-software.title'),
      description: t('pages.blog.free-traffic-that-converts-with-special-software.description'),
      link: '/blog/free-traffic-that-converts-with-special-software',
    },
    {
      title: t('pages.blog.how-to-get-free-visitors-to-your-website.title'),
      description: t('pages.blog.how-to-get-free-visitors-to-your-website.description'),
      link: '/blog/how-to-get-free-visitors-to-your-website',
    },
    {
      title: t('pages.blog.real-free-website-traffic-with-our-bot.title'),
      description: t('pages.blog.real-free-website-traffic-with-our-bot.description'),
      link: '/blog/real-free-website-traffic-with-our-bot',
    },
    {
      title: t('pages.blog.what-is-website-traffic-and-how-to-manage-it-for-your-profit.title'),
      description: t('pages.blog.what-is-website-traffic-and-how-to-manage-it-for-your-profit.description'),
      link: '/blog/what-is-website-traffic-and-how-to-manage-it-for-your-profit',
    },
    {
      title: t('pages.blog.what-is-traffic-and-how-to-use-it-for-your-goals.title'),
      description: t('pages.blog.what-is-traffic-and-how-to-use-it-for-your-goals.description'),
      link: '/blog/what-is-traffic-and-how-to-use-it-for-your-goals',
    },
    {
      title: t('pages.blog.what-are-free-traffic-websites-and-why-are-they-useful.title'),
      description: t('pages.blog.what-are-free-traffic-websites-and-why-are-they-useful.description'),
      link: '/blog/what-are-free-traffic-websites-and-why-are-they-useful',
    },
    {
      title: t('pages.blog.website-unique-visitors-and-several-hints-on-how-to-increase-their-number.title'),
      description: t(
        'pages.blog.website-unique-visitors-and-several-hints-on-how-to-increase-their-number.description'
      ),
      link: '/blog/website-unique-visitors-and-several-hints-on-how-to-increase-their-number',
    },
    {
      title: t('pages.blog.traffic-matters.title'),
      description: t('pages.blog.traffic-matters.description'),
      link: '/blog/traffic-matters',
    },
    {
      title: t('pages.blog.the-importance-of-website-traffic-and-the-ways-to-increase-it.title'),
      description: t('pages.blog.the-importance-of-website-traffic-and-the-ways-to-increase-it.description'),
      link: '/blog/the-importance-of-website-traffic-and-the-ways-to-increase-it',
    },
    {
      title: t('pages.blog.starting-your-successful-website-traffic-generating-what-tools-to-use.title'),
      description: t('pages.blog.starting-your-successful-website-traffic-generating-what-tools-to-use.description'),
      link: '/blog/starting-your-successful-website-traffic-generating-what-tools-to-use',
    },
    {
      title: t('pages.blog.how-to-increase-traffic-levels-of-your-website-with-no-expenses.title'),
      description: t('pages.blog.how-to-increase-traffic-levels-of-your-website-with-no-expenses.description'),
      link: '/blog/how-to-increase-traffic-levels-of-your-website-with-no-expenses',
    },
    {
      title: t('pages.blog.how-to-get-more-website-views.title'),
      description: t('pages.blog.how-to-get-more-website-views.description'),
      link: '/blog/how-to-get-more-website-views',
    },
    {
      title: t('pages.blog.get_your_website_traffic_for_free_with_trial_period.title'),
      description: t('pages.blog.get_your_website_traffic_for_free_with_trial_period.description'),
      link: '/blog/get-your-website-traffic-for-free-with-trial-period',
    },
    {
      title: t('pages.blog.HowToImproveSeoRank.articleTitle'),
      description: t('pages.blog.HowToImproveSeoRank.p1'),
      link: '/blog/how-to-improve-seo-rank',
    },
  ];

  return (
    <div className="animate__animated animate__fadeIn">
      <Head>
        <title>Blog</title>
      </Head>

      <h1>Blog</h1>

      {list.map((post) => {
        return (
          <Row key={post.link}>
            <Col className="px-0">
              <Post>
                <CardBody>
                  <PostTitle>
                    <Link href={post.link}>{post.title}</Link>
                  </PostTitle>
                  <p>{post.description}</p>
                </CardBody>
              </Post>
            </Col>
          </Row>
        );
      })}
    </div>
  );
};

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
    },
  };
}

Blog.getLayout = (page) => getLayout(page);

export default Blog;
